document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-description-toggle').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const wrapper = button.closest('.product-description-collapsible');
      if (!wrapper) return;

      const expanded = wrapper.getAttribute('data-expanded') === 'true';
      wrapper.setAttribute('data-expanded', String(!expanded));

      button.querySelector('.read-more').style.display = expanded ? 'inline' : 'none';
      button.querySelector('.read-less').style.display = expanded ? 'none' : 'inline';
    });
  });
});
